export const EXPIRED = "expired";
export const WRONG_CODE = "wrong_code";
export const UNDERAGE = "underage";
